import { render, staticRenderFns } from "./properties-block-glyph.vue?vue&type=template&id=a418708c&scoped=true"
import script from "./properties-block-glyph.vue?vue&type=script&lang=js"
export * from "./properties-block-glyph.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a418708c",
  null
  
)

export default component.exports